import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const state = {
  token: localStorage.getItem('user-token') || '',
  user: null,
  trainer: null,
  runner: null,
  runnersTrainer: null,
  trainerRunners: [],
  adminRunners: [],
  adminTrainers: [],
  initial: {
    allPackages: [],
    allTrainers: [],
    allWorkoutsTemplates: [],
    racePriorities: [
      'A', 'B', 'C'
    ],
    raceTypesStrings: [
      {
        text: 'ulica',
        value: 'street'
      },
      {
        text: 'bieżnia',
        value: 'track'
      },
      {
        text: 'przełaj',
        value: 'cross'
      },
      {
        text: 'góry',
        value: 'mountains'
      },
      {
        text: 'bieg przeszkodowy',
        value: 'obstacle'
      }
    ],
    recordsRaceTypesStrings: [
      {
        text: 'ulica',
        value: 'street'
      },
      {
        text: 'bieżnia',
        value: 'track'
      }
    ],
    raceDistanceStrings: [
      {
        text: '100m',
        value: '100m'
      },
      {
        text: '200m',
        value: '200m'
      },
      {
        text: '400m',
        value: '400m'
      },
      {
        text: '800m',
        value: '800m'
      },
      {
        text: '1000m',
        value: '1000m'
      },
      {
        text: '1500m',
        value: '1500m'
      },
      {
        text: '3000m',
        value: '3000m'
      },
      {
        text: '3000m z p.',
        value: '3000m s.'
      },
      {
        text: '5000m',
        value: '5000m'
      },
      {
        text: '10 000m',
        value: '10000m'
      },
      {
        text: '5km',
        value: '5km'
      },
      {
        text: '10km',
        value: '10km'
      },
      {
        text: '15km',
        value: '15km'
      },
      {
        text: 'półmaraton',
        value: '21km'
      },
      {
        text: 'maraton',
        value: '42km'
      },
      {
        text: '100km',
        value: '100km'
      },
      {
        text: 'ultra',
        value: 'ultra'
      },
      {
        text: 'inne',
        value: 'other'
      }
    ],
    raceDistanceTrackStrings: [
      {
        text: '100m',
        value: '100m'
      },
      {
        text: '200m',
        value: '200m'
      },
      {
        text: '400m',
        value: '400m'
      },
      {
        text: '800m',
        value: '800m'
      },
      {
        text: '1000m',
        value: '1000m'
      },
      {
        text: '1500m',
        value: '1500m'
      },
      {
        text: '3000m',
        value: '3000m'
      },
      {
        text: '3000m z p.',
        value: '3000m s.'
      },
      {
        text: '5000m',
        value: '5000m'
      },
      {
        text: '10 000m',
        value: '10000m'
      }
    ],
    raceDistanceStreetStrings: [
      {
        text: '5km',
        value: '5km'
      },
      {
        text: '10km',
        value: '10km'
      },
      {
        text: '15km',
        value: '15km'
      },
      {
        text: 'półmaraton',
        value: '21km'
      },
      {
        text: 'maraton',
        value: '42km'
      },
      {
        text: '100km',
        value: '100km'
      },
      {
        text: 'ultra',
        value: 'ultra'
      },
      {
        text: 'inne',
        value: 'other'
      }
    ],
    measurableRaceDistanceStreetStrings: [
      {
        text: '5km',
        value: '5km'
      },
      {
        text: '10km',
        value: '10km'
      },
      {
        text: '15km',
        value: '15km'
      },
      {
        text: 'półmaraton',
        value: '21km'
      },
      {
        text: 'maraton',
        value: '42km'
      },
      {
        text: '100km',
        value: '100km'
      }
    ],
    measurableRaceDistanceStrings: [
      {
        text: '100m',
        value: '100m'
      },
      {
        text: '200m',
        value: '200m'
      },
      {
        text: '400m',
        value: '400m'
      },
      {
        text: '800m',
        value: '800m'
      },
      {
        text: '1000m',
        value: '1000m'
      },
      {
        text: '1500m',
        value: '1500m'
      },
      {
        text: '3000m',
        value: '3000m'
      },
      {
        text: '3000m z p.',
        value: '3000m s.'
      },
      {
        text: '5000m',
        value: '5000m'
      },
      {
        text: '10 000m',
        value: '10000m'
      },
      {
        text: '5km',
        value: '5km'
      },
      {
        text: '10km',
        value: '10km'
      },
      {
        text: '15km',
        value: '15km'
      },
      {
        text: 'półmaraton',
        value: '21km'
      },
      {
        text: 'maraton',
        value: '42km'
      },
      {
        text: '100km',
        value: '100km'
      }
    ],
    raceFrequency: [
      {
        text: 'Raz do roku lub rzadziej',
        value: 1
      },
      {
        text: '2-6 razy w roku',
        value: 2
      },
      {
        text: '1-2 razy w miesiącu',
        value: 3
      },
      {
        text: 'Raz na tydzień lub częściej',
        value: 4
      }
    ],
    tshirtSize: [
      {
        text: 'Męska S',
        value: 1
      },
      {
        text: 'Męska M',
        value: 2
      },
      {
        text: 'Męska L',
        value: 3
      },
      {
        text: 'Męska XL',
        value: 4
      },
      {
        text: 'Męska XXL',
        value: 5
      },
      {
        text: 'Damska S',
        value: 6
      },
      {
        text: 'Damska M',
        value: 7
      },
      {
        text: 'Damska L',
        value: 8
      },
      {
        text: 'Damska XL',
        value: 9
      }
    ]
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js